import { Theme } from 'theme-ui'
import { colors } from './colors'
import { text } from './text'
import { styles } from './styles'
import { fonts, fontSizes, fontWeights } from './typography'

const theme: Theme = {
  breakpoints: ['40em', '52em', '64em'],
  colors,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  links: {
    hero: {
      color: 'white',
    },
    button: {
      fontSize: [2, 2],
      display: 'inline-block',
      fontFamily: 'heading',
      fontWeight: '600',
      width: ['100%', 'initial'],
      textDecoration: 'none',
      textAlign: 'center',
      color: 'white',
      backgroundColor: 'red',
      borderRadius: 5,
      paddingX: 4,
      paddingY: 2,
      mb: 3,
      '&:hover': {
        backgroundColor: 'lightRed',
      },
    },
    buttonInverted: {
      variant: 'links.button',
      backgroundColor: 'white',
      color: 'red',
      '&:hover': {
        backgroundColor: 'neutral.100',
      },
    },
  },
  layout: {
    container: {
      px: [4, 8],
      maxWidth: '1200px',
    },
  },
  sizes: {
    container: 1200,
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  styles,
  text,
}

export default theme
